import {Component, EventEmitter, Input, Output} from '@angular/core';

export enum View {
  TOP = 'TOP_VIEW',
  BOTTOM = 'BOTTOM_VIEW',
  LEFT = 'LEFT_VIEW',
  RIGHT = 'RIGHT_VIEW',
  FRONT = 'FRONT_VIEW',
  BACK = 'BACK_VIEW'
}

@Component({
  selector: 'app-camera-controls',
  templateUrl: './camera-controls.component.html',
  styleUrls: ['./camera-controls.component.scss']
})
export class CameraControlsComponent {
  @Input() views: any;
  @Output()
  public changeCamera: EventEmitter<View> = new EventEmitter();

  constructor() {
  }

  public isView(cameraStand: any) {
    return Object.values(View).includes(cameraStand.position);
  }
}
